/* ════════════════════════════════════════════════════════════
   أصول العلامة — مصدر واحد لا ثانيَ له

   لماذا ملفّ مستقلّ بلا أيّ استيراد؟ لأنّ الشعار يحتاجه **كل** شيء:
   مكوّنات العميل، ومكوّنات الخادم (`not-found.tsx`)، وشاشة التحميل
   التي تعمل قبل أن تتّصل قاعدة البيانات. ولو سكنت هذه الثوابت في
   `use-site-settings.ts` لجرّ كلُّ من استوردها Firebase معه إلى حزمة
   الخادم — تبعيّة لا يحتاجها من أراد اسم ملفّ صورة.

   ملفّ ورقة (leaf) بلا تبعيّات: يستورده من شاء بلا ثمن.

   وأيّ شعار مخصّص يرفعه الأدمن من لوحة الإعدادات يغلب هذه القيمة —
   هذه هي الأرضيّة لا السقف.
   ════════════════════════════════════════════════════════════ */

/** الشعار المعروض في الواجهة (SVG — يكبر بلا تحبّب) */
export const DEFAULT_LOGO = "/icon.svg";

/** أيقونة التبويب والشاشة الرئيسية (PNG — أوسع دعماً من SVG) */
export const DEFAULT_FAVICON = "/icon-192.png";
